import { ActivatedRoute, Data, Route, Router, UrlTree } from '@angular/router';
import { NavigationInfo, Routing } from '@barthauer/abc/core';

export class WebApiEditorComponentInfo {
  public static readonly ROUTE_PATH: string = 'webapi-editor';
  public static readonly ROUTE_MARKER_TAG: string = 'webapi-editor';

  public static isChangingWebApiSupported(router: Router): boolean {
    return Routing.findRoute(router.config, this.ROUTE_PATH, this.ROUTE_MARKER_TAG) ? true : false;
  }

  public static getWebApiEditorPageRoute(router: Router): Route {
    return Routing.findRoute(router.config, this.ROUTE_PATH, this.ROUTE_MARKER_TAG);
  }

  public static isCurrentPageWebApiEditorPage(router: Router): boolean {
    return Routing.doesCurrentPageMatchRoute(router, this.getWebApiEditorPageRoute(router));
  }

  public static createWebApiEditorPageNavigationInfo(
    router: Router,
    route: ActivatedRoute,
    forwardTo?: string
  ): NavigationInfo {
    const webApiEditorPageRoute: Route = Routing.findRoute(router.config, this.ROUTE_PATH, this.ROUTE_MARKER_TAG);

    if (!webApiEditorPageRoute) {
      throw new Error('WebApi Editor page route not found!');
    }

    let routeData: Data = undefined;

    if (forwardTo) {
      routeData = { ForwardTo: forwardTo };
    }

    return Routing.createNavigationInfo(webApiEditorPageRoute, route, routeData);
  }

  public static navigateToWebApiEditorPage(
    router: Router,
    route: ActivatedRoute,
    forwardTo?: string
  ): Promise<boolean> {
    const naviInfo: NavigationInfo = this.createWebApiEditorPageNavigationInfo(router, route, forwardTo);

    return router.navigate(naviInfo.Commands, naviInfo.Extras);
  }

  public static createWebApiEditorPageUrlTree(router: Router, route: ActivatedRoute, forwardTo?: string): UrlTree {
    const naviInfo: NavigationInfo = this.createWebApiEditorPageNavigationInfo(router, route, forwardTo);

    return router.createUrlTree(naviInfo.Commands, naviInfo.Extras);
  }
}
